(() => {
  const root = document.getElementById('p2');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  const q = (s) => root.querySelector(s);
  const qa = (s) => [...root.querySelectorAll(s)];
  if (/[?&]quiz=1/.test(location.search)) { const b = q('[data-p2-quiz]'); if (b) b.hidden = false; }

  // gallery: swipe + thumbs + dots
  const track = q('[data-p2-track]');
  const thumbs = qa('[data-p2-thumbs] button');
  const dots = qa('[data-p2-dots] i');
  thumbs.forEach((t) => t.addEventListener('click', () => track.scrollTo({ left: +t.dataset.i * track.clientWidth, behavior: 'smooth' })));
  track && track.addEventListener('scroll', () => {
    const i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
    thumbs.forEach((t, k) => t.classList.toggle('is-on', k === i));
    dots.forEach((d, k) => d.classList.toggle('is-on', k === i));
  }, { passive: true });

  // bundle bars + progressive gifts
  const bars = qa('.p2-bar');
  const g3 = q('[data-p2-g3]');
  let cur = bars.find((b) => b.classList.contains('is-on')) || bars[0];
  const set = (sel, v) => { root.querySelectorAll(sel).forEach((el) => { el.textContent = v; }); };
  function pick(b) {
    bars.forEach((x) => { const on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-checked', on ? 'true' : 'false'); });
    cur = b;
    set('[data-p2-now]', b.dataset.now); set('[data-p2-was]', b.dataset.was);
    document.querySelectorAll('.p2-sticky [data-p2-now]').forEach((el) => { el.textContent = b.dataset.now; });
    document.querySelectorAll('.p2-sticky [data-p2-was]').forEach((el) => { el.textContent = b.dataset.was; });
    set('[data-p2-atc-now]', b.dataset.now); set('[data-p2-atc-was]', b.dataset.was); set('[data-p2-sticky-now]', b.dataset.now);
    if (g3) g3.classList.toggle('is-on', b.dataset.tier === '3');
  }
  bars.forEach((b) => b.addEventListener('click', () => pick(b)));
  const tier = new URLSearchParams(location.search).get('tier');
  pick(tier && bars[+tier - 1] ? bars[+tier - 1] : cur);

  // add to cart: bundle + free gifts, then open the cart drawer
  const btn = q('[data-p2-atc]');
  const err = q('[data-p2-err]');
  async function add() {
    btn.setAttribute('aria-busy', 'true'); err.hidden = true;
    try {
      const cart = await fetch('/cart.js').then((r) => r.json());
      const has = (id) => cart.items.some((i) => String(i.variant_id) === String(id));
      const items = [{ id: +cur.dataset.v, quantity: 1 }];
      if (root.dataset.gift && !has(root.dataset.gift)) items.push({ id: +root.dataset.gift, quantity: 1, properties: { _gift: 'yes' } });
      if (cur.dataset.tier === '3' && root.dataset.guide && !has(root.dataset.guide)) items.push({ id: +root.dataset.guide, quantity: 1, properties: { _gift: 'yes' } });
      const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      if (!r.ok) throw new Error('add');
      if (window.hRefreshDrawer) await window.hRefreshDrawer(); else location.href = '/cart';
    } catch (e) { err.hidden = false; }
    btn.removeAttribute('aria-busy');
  }
  btn.addEventListener('click', add);

  // sticky ATC on mobile
  const st = document.querySelector('[data-p2-sticky]');
  if (st) {
    const upd = () => st.classList.toggle('is-on', btn.getBoundingClientRect().bottom < 0);
    window.addEventListener('scroll', upd, { passive: true }); upd();
    st.querySelector('[data-p2-sticky-btn]').addEventListener('click', () => (document.getElementById('h-buy') || btn).scrollIntoView({ behavior: 'smooth', block: 'center' }));
  }

  // evergreen timer (per browser session)
  const t = q('[data-p2-timer]');
  if (t) {
    let end = 0; try { end = +sessionStorage.getItem('p2_end') || 0; } catch (e) {}
    if (!end || end < Date.now()) { end = Date.now() + (5 * 3600 + 91) * 1000; try { sessionStorage.setItem('p2_end', end); } catch (e) {} }
    const p = (n) => String(n).padStart(2, '0');
    const tick = () => { const s = Math.max(0, Math.floor((end - Date.now()) / 1000)); t.textContent = `${p(Math.floor(s / 3600))}:${p(Math.floor((s % 3600) / 60))}:${p(s % 60)}`; };
    tick(); setInterval(tick, 1000);
  }
})();
